/**
 * this service is private and meant to be used by TableColumnExtenderDataInputMenuMixin only!
 */

import { PREVIOUS_STEP_TABLE_OUTPUT, SET_VALUE_FROM_TABLE_SOURCE } from '../../../../DataInput/DataInputMenu/helpers/data-input-menu.const';

// helper methods of service

// methods exported by service
const addTableColumnsTabItem = function () {
	const fieldName = 'Table';
	this.addTabItem(PREVIOUS_STEP_TABLE_OUTPUT, fieldName, false);
};
const addTableColumnListenerDataInput = function () {
	this.addDataInputMenuListener(SET_VALUE_FROM_TABLE_SOURCE, this.updateLocalValueFromTable);
};
const setTableColumnDataInputMenuProps = function () {
	Object.entries(this.tableColumnDataInputMenuProps).forEach(([key, value]) => this.setDataInputMenuProp(key, value));
};

const TableColumnExtenderDataInputMenuMixinService = {
	addTableColumnsTabItem,
	addTableColumnListenerDataInput,
	setTableColumnDataInputMenuProps,
};

export default TableColumnExtenderDataInputMenuMixinService;
